var React = require('react');

function SocialTiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.2265 0H10.8559V13.6232C10.8559 15.2464 9.55951 16.5797 7.94624 16.5797C6.33296 16.5797 5.03659 15.2464 5.03659 13.6232C5.03659 12.029 6.30416 10.7246 7.85983 10.6667V7.24639C4.43161 7.30433 1.66602 10.1159 1.66602 13.6232C1.66602 17.1594 4.48923 20 7.97506 20C11.4608 20 14.284 17.1304 14.284 13.6232V6.63767C15.5516 7.56522 17.1073 8.11594 18.7493 8.14495V4.72464C16.2142 4.63768 14.2265 2.55072 14.2265 0Z","fill":"#22202F"}));
}

SocialTiktok.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = SocialTiktok;

SocialTiktok.default = SocialTiktok;
